import { AddOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';

export const AddButton = () => (
  <Button disabled variant="outlined" color="warning" startIcon={<AddOutlined />}>
    Add
  </Button>
);
